const getToken = () => {
    const tokenString = localStorage.getItem("token-ideas");
    const userToken = tokenString;

    return userToken;
};

const getHeaders = () => {
    const token = getToken();
    const header = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    };
    return header;
};
export default { getHeaders, getToken };
